<template>
  <view class="packet"style wx:style="{{style}}">
    <view class="title">{{ title }}</view>
    <view wx:if="{{couponInfo}}" class="info {{numberDigit}}">
      <text wx:if="{{couponTip}}" class="tip">{{couponTip}}</text>
      <text class="integer">{{valueObj.integer}}
      </text><text wx:if="{{valueObj.point}}" class="point">{{valueObj.point}}
      </text><text class="decimal">{{valueObj.decimal}}</text>
      <text class="unit">{{couponInfo.max_benefit_capacity.unit}}</text>
    </view>
    <!-- <button wx:if="{{!isSupportWxTag}}" class="btn" bindtap="click">{{ btnText }}</button>
    <wx-launch-app-btn
      wx:else
      jumpTargetScheme="{{ jumpTargetScheme }}"
      btnText="{{ btnText }}"
      bind:launchApp="launchApp"
    /> -->
    <view class="btn-wrapper">
      <!-- <button wx:if="{{!isSupportWxTag}}" class="btn" bindtap="click">{{ btnText }}</button> -->
      <view wx:if="{{!isSupportWxTag}}" class="btn" bindtap="click">{{ btnText }}</view>
      <launch-app-btn
        wx:else
        jumpTargetScheme="{{ jumpTargetScheme }}"
        btnText="{{ btnText }}"
        bind:launchApp="launchApp"
      />
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { is, getInvokeAppInfo, compareVersion } from '@didi/webx-js'
import { formatValue } from '../../lib/utils'
import { getStyle } from '../../lib/editor/utils'
import store from '../../lib/store'

const typeMap = {
  1: '最高',
  3: '最高',
  100: '低至',
}

createComponent({
  properties: {
    config: Object,
    couponInfo: Object,
    btnText: String,
    packetType: {
      type: String,
      value: '',
    },
  },
  data: {
    isSupportWxTag: false,
    envSupport: false,
    jumpTargetScheme: '',
  },
  computed: {
    ...store.mapGetters([
      'query',
      'initData',
    ]),
    valueObj() {
      return formatValue(this.couponInfo.max_benefit_capacity.value)
    },
    couponTip() {
      return typeMap[this.couponInfo.type]
    },
    title() {
      return this.config?._closeTitle || '滴滴出行专享'
    },
    numberDigit() {
      const len = String(this.valueObj.integer).length + String(this.valueObj.decimal).length + String(this.valueObj.point).length
      if (len >= 3)
        return 'digit-3'
      else
        return `digit-${len}`
    },
    style() {
      return getStyle(this.config?.style)
    },
  },
  methods: {
    click(e) {
      this.triggerEvent('click', e.detail)
    },
    launchApp() {
      this.triggerEvent('launchApp')
    },
    envSupportWxTag() {
      const envSupport = this.envSupport
      if (envSupport) return envSupport

      // 微信开发标签拉端目前只支持 page.udache.com 域名
      if (window.location.host !== 'page.udache.com') return false

      console.log('=======当前是否安卓微信h5环境======== ', is('weixin.android'))
      // 只支持微信环境
      if (!is('weixin.android')) return false

      // 微信版本 需要大于等于 7.0.12
      const UA = window.navigator.userAgent
      const wechatInfo = UA.match(/MicroMessenger\/([\d.]+)/i)
      const wechatVersion = wechatInfo && wechatInfo[1]

      console.log('=======envSupportWxTag===== ', compareVersion(wechatVersion, '7.0.12'), wechatVersion)
      if (compareVersion(wechatVersion, '7.0.12') < 0) return false

      this.envSupport = true
      return true
    },
    async judegeIsUseWxTag() {
      if (!this.envSupportWxTag()) return
      const splitUrl = this.initData.activity_info.app_link.split('/')
      const key = splitUrl[splitUrl.length - 1]
      const dchn = key && key.indexOf('?') ? key.split('?')[0] : key
      const launchAppParams = {
        launchAppDchn: dchn,
        // env: 'online',
        invokePriority: 'app',
        morePriority: [ 'app', 'download' ],
        isAutoInvokeApp: true,
        isUseWeixinTag: true,
        isCopyCmd: true,
        cmdParams: {
          dsi: this.query.dsi,
          source_id: this.query.source_id,
          dunion_callback: this.query.dunion_callback,
        },
        extra: {
          guidePageUrl: this.initData.activity_info.app_link,
          bottomUiIcon: 'https://dpubstatic.udache.com/static/dpubimg/cXjI97vdBvqFvACBUqPHk.png',
          trackParams: {
            dsi: this.query.dsi,
            source_id: this.query.source_id,
          },
        },
      }
      getInvokeAppInfo(launchAppParams).then(res => {
        const mainDeepLinks = res?.conf?.mainDeepLinks || {}
        let mainDeepLinksItem = {}
        if (Array.isArray(mainDeepLinks) && mainDeepLinks.length >= 1) {
          mainDeepLinksItem = mainDeepLinks[0]
        }

        console.log('=======judegeIsUseWxTag====== ', res, mainDeepLinksItem, mainDeepLinks)
        // 支持使用微信开放标签
        if (mainDeepLinksItem && mainDeepLinksItem.linkType === 8) {
          this.jumpTargetScheme = mainDeepLinksItem.link
          this.isSupportWxTag = true
        }
      })
    },
  },
  attached() {
    if (this.packetType === 'launch-app') {
      this.judegeIsUseWxTag()
    }
  },
})
</script>

<script name="json">
const config = {
  "component": true,
  "usingComponents": {
    "coupon-price": "../common/coupon-price.mpx"
  }
}
if (__mpx_mode__ === 'web') {
  config.usingComponents['launch-app-btn'] = './wx-launch-app-btn.mpx'
}
module.exports = config
</script>

<style lang="stylus" scoped>
  // 0123456789
  @font-face {
    font-family: DIN-Black-self;
    src: url(https://ut-static.udache.com/webx/ut/IaTeiNIYsw6lOMfe0Q9Lm.ttf);
  }
  .packet
    box-sizing: border-box;
    width 735rpx
    height 744rpx
    overflow hidden
    position relative
    padding 46rpx 0 0 0
    .title
      text-align center
      font-size: 40rpx;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height 1
    .info
      padding-left: 48rpx
      // margin-top 10rpx
      font-size: 350rpx;
      font-family: DIN-Black, DIN-Black-self;
      font-weight: 900;
      color: #FFFFFF;
      text-shadow: 0 5rpx 0 #E10F00;
      display flex
      justify-content: center;
      align-items: flex-end;
      line-height: 1;
      letter-spacing -10rpx
      position relative
      &.digit-3
        margin-top 58rpx
        font-size 240rpx
        padding-left 32rpx
        .point
          margin-left 0
          margin-right -8rpx
        .unit
          font-size: 60rpx;
        .tip
          top: -56rpx;
      &.digit-2
        margin-top 28rpx
        font-size 300rpx
        .tip
          top: -4px;
        .unit
          font-size: 72rpx;
      .tip
        position absolute
        top 52rpx
        left 124rpx
        font-size: 28rpx;
        line-height: 32rpx;
        font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
        font-weight: 400;
        color: #FFFFFF;
        text-shadow: 0px 1px 0px rgba(212, 110, 70, 0.83);
        letter-spacing 0
        width 53rpx
        box-sizing: border-box;
        padding 14rpx 0 14rpx 10rpx
        align-self: flex-start;
        border: 3rpx solid rgba(255,255,255,1);
        border-radius: 38rpx;
    .unit
      font-size: 84rpx;
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      color: #FFFFFF;
      position relative
      left 16rpx
      top -24rpx
    .point
      margin-left -6rpx
      margin-right -16rpx
    .btn-wrapper, .limit
      position absolute
      left 50%
      transform translate(-50%)
    .btn-wrapper
      background-image: linear-gradient(180deg, #FFFEEF 0%, #FAE5A7 100%);
      box-shadow: 0px 10rpx 19rpx 0px rgba(169,6,6,0.48);
      border-radius: 59rpx;
      width 472rpx
      height 118rpx
      line-height 124rpx
      bottom 64rpx
      font-size: 51rpx;
      font-family: PingFang SC;
      font-weight: bold;
      color: #E34F49;
      text-align center
      overflow hidden
      .btn
        // background-image: linear-gradient(180deg, #FFFEEF 0%, #FAE5A7 100%);
        // box-shadow: 0px 10rpx 19rpx 0px rgba(169,6,6,0.48);
        // border-radius: 59rpx;
        // width 472rpx
        // height 118rpx
        // line-height 124rpx
        // bottom 64rpx
        // font-size: 51rpx;
        // font-family: PingFang SC;
        // font-weight: bold;
        // color: #E34F49;
        // text-align center
    .limit
      bottom 44rpx
      font-size: 24rpx;
      font-family: PingFang SC;
      font-weight: 300;
      color: #962412;
</style>

